import styled from 'styled-components';

const Svg = styled.svg`
  ${({ theme: { spacing } }) => `
    width: ${spacing(6)};
    height: ${spacing(6)};
  `}
`;

type Props = {
  color: string;
  className?: string;
};

export const ThumbsDown = ({ className = '', color }: Props) => (
  <Svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17 2V13M22 11V4C22 2.89543 21.1046 2 20 2H6.57376C5.09298 2 3.83384 3.08027 3.60859 4.54382L2.53173 11.5438C2.25213 13.3611 3.65824 15 5.49678 15H9C9.55228 15 10 15.4477 10 16V19.5342C10 20.896 11.104 22 12.4658 22C12.7907 22 13.085 21.8087 13.2169 21.5119L16.7351 13.5939C16.8954 13.2332 17.2532 13 17.6479 13H20C21.1046 13 22 12.1046 22 11Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);
